<template lang="pug">
    layout-page(v-if="!$apollo.loading")
        student-homepage(v-if="user.is_student")
        admin-homepage(v-else-if="user.is_admin")
        employee-homepage(v-else)
</template>

<script>
import gql from "graphql-tag";
import EmployeeHomepage from "@/components/apps/appsList/cards/employee/Homepage";
import StudentHomepage from "@/components/apps/appsList/cards/student/Homepage";
import AdminHomepage from "@/components/apps/appsList/cards/admin/Homepage";

export default {
	components: {
		AdminHomepage,
		EmployeeHomepage,
		StudentHomepage
	},
	props: {
		noAccess: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if (this.noAccess) {
			this.$message({
				type: "error",
				message: "You do not have access to view this page"
			});
		}
	},
	apollo: {
		user: {
			query: gql`
				{
					User {
						id
						is_student
						is_admin
					}
				}
			`,
			update: r => r.User
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/pages/Index.vue